registerComponent("sections/historia", function (component) {
/**
 * sections/historia — a entrada na rolagem (ADR 0051): rótulo, título,
 * parágrafo e CTA entram escalonados quando o painel chega na tela, e desde
 * 11/09 (ADR 0107) as TRÊS FOTOS da colagem entram atrás deles, como blocos.
 * O mapa e o véu não entram: são o fundo dela, e fundo que sobe lê como a
 * seção inteira deslizando.
 *
 * ⚠️ A ordem da cascata é a do DOCUMENTO (ver `Asa.armarEntrada`), e é por isso
 * que a colagem vem depois do `.historia__inner` no HTML — com ela na frente,
 * as fotos gastavam as três primeiras posições e o texto esperava 0,39s.
 *
 * O giro do celular e o parallax das fotos são só CSS (`rotate` e uma linha do
 * tempo de rolagem em `translate`, em _historia.less): nada aqui.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada([component], '.entrada');

});
